import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const LoadingCabecalho = () => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
    <CircularProgress size={24} thickness={4} color="secondary" />
  </div>
);

export default LoadingCabecalho;
